import { MutationTree } from "vuex";
import { ISecurityState } from "./state";
import { IAppointmentSecurityDay, ITransporter, IAppointment, AppointmentType } from "@/models";

import {
    ADD_SECURITY_DAY,
    APPOINTMENT_UPDATED,
    APPOINTMENT_RECEPTION_CREATED,
    APPOINTMENT_EXPEDITION_CREATED,
    SET_SELECTED_APPOINTMENT,
    APPOINTMENT_DELETED,
} from "./mutations-types";
import Vue from "vue";

export const mutations: MutationTree<ISecurityState> = {

    [ADD_SECURITY_DAY](state, payload: IAppointmentSecurityDay): void {
        state.securityDay = payload;
    },

    [APPOINTMENT_UPDATED](state, payload: IAppointment): void {
        if (new Date(state.securityDay.day).getDate() === new Date(payload.expectedArrival).getDate()) {
            const appointmentSlot = state.securityDay.appointmentsSlots.find(x => x.slotId === payload.slotId);

            if (payload.type === AppointmentType.Expedition) {
                const index = appointmentSlot.expeditions.findIndex(x => x.appointmentId === payload.appointmentId);

                Vue.set(appointmentSlot.expeditions, index, payload);
            }
            else {
                const index = appointmentSlot.receptions.findIndex(x => x.appointmentId === payload.appointmentId);

                Vue.set(appointmentSlot.receptions, index, payload);
            }
        }
    },

    [APPOINTMENT_RECEPTION_CREATED](state, payload: IAppointment): void {
        if (new Date(state.securityDay.day).getDate() === new Date(payload.expectedArrival).getDate()) {
            const appointmentSlot = state.securityDay.appointmentsSlots.find(x => x.slotId === payload.slotId);

            if (appointmentSlot) {
                appointmentSlot.receptions.push(payload);
            }
            else {
                state.securityDay.appointmentsSlots.push({ slotId: payload.slotId, receptions: [payload], expeditions: [] });
            }

        }
    },

    [APPOINTMENT_EXPEDITION_CREATED](state, payload: IAppointment): void {
        if (new Date(state.securityDay.day).getDate() === new Date(payload.expectedArrival).getDate()) {
            const appointmentSlot = state.securityDay.appointmentsSlots.find(x => x.slotId === payload.slotId);

            if (appointmentSlot) {
                appointmentSlot.expeditions.push(payload);
            }
            else {
                state.securityDay.appointmentsSlots.push({ slotId: payload.slotId, expeditions: [payload], receptions: [] });
            }
        }
    },

    [SET_SELECTED_APPOINTMENT](state, payload: IAppointment): void {
        state.selectedAppointment = payload;
    },

    [APPOINTMENT_DELETED](state, payload: IAppointment): void {
        if (new Date(state.securityDay.day).getDate() === new Date(payload.expectedArrival).getDate()) {
            const appointmentSlot = state.securityDay.appointmentsSlots.find(x => x.slotId === payload.slotId);

            let index: number = 0;

            if (payload.type === AppointmentType.Expedition) {
                index = appointmentSlot.expeditions.findIndex(x => x.appointmentId === payload.appointmentId);

                appointmentSlot.expeditions.splice(index, 1);
            }
            else {
                index = appointmentSlot.receptions.findIndex(x => x.appointmentId === payload.appointmentId);

                appointmentSlot.receptions.splice(index, 1);
            }

            if (appointmentSlot.expeditions.length === 0 && appointmentSlot.receptions.length === 0) {
                const indexAppointmentSlot = state.securityDay.appointmentsSlots.findIndex(x => x.slotId === payload.slotId);
                state.securityDay.appointmentsSlots.splice(indexAppointmentSlot, 1);
            }
        }
    },
};
